import {Injectable, signal, WritableSignal} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpService} from "../../../services/http/http.service";
import {
  CreateDeeplinkDto,
  CreateInvitesLinkDto,
  CreateShoutPlusInviteLinkDto,
  ShoutPlusAutoApproveSetting
} from '../../models/invites';

@Injectable({
  providedIn: 'root'
})
export class InvitesService {

  public BusinessInviteLinkDataSignal: WritableSignal<CreateShoutPlusInviteLinkDto | null> = signal(null);

  public auto_approve_settings_signal: WritableSignal<ShoutPlusAutoApproveSetting | null> = signal(null);

  constructor(
    private httpService: HttpService
  ) { }

  generateInviteLink(body: CreateDeeplinkDto): Observable<string> {
    return this.httpService.runHttpCall(
      "POST",
      `/deeplinks`,
      "application/json",
      body
    )
  }

  getInviteLink(business_account_id: string): Observable<CreateShoutPlusInviteLinkDto> {
    return this.httpService.runHttpCall(
      "GET",
      `/shout-plus/invite-link/business/${business_account_id}`,
      "application/json"
    )
  }

  createShortLink(body: CreateShoutPlusInviteLinkDto): Observable<any> {
    return this.httpService.runHttpCall(
      "POST",
      `/cta-links/link`,
      "application/json",
      body
    )
  }

  getInvite(invite_id: string): Observable<any> {
    return this.httpService.runHttpCall(
      "GET",
      `/shout-plus/invite/${invite_id}`,
      "application/json"
    )
  }

  createAutoApproveSettings(body: ShoutPlusAutoApproveSetting): Observable<ShoutPlusAutoApproveSetting> {
    return this.httpService.runHttpCall(
      "POST",
      `/shout-plus/auto-approve-settings`,
      "application/json",
      body
    )
  }

  updateAutoApproveSettings(id: string, body: Partial<ShoutPlusAutoApproveSetting>): Observable<ShoutPlusAutoApproveSetting> {
    return this.httpService.runHttpCall(
      "PATCH",
      `/shout-plus/auto-approve-settings/${id}`,
      "application/json",
      body
    )
  }

  
  getAutoApproveSettingsForBusiness(business_account_id: string): Observable<ShoutPlusAutoApproveSetting> {
    return this.httpService.runHttpCall(
      "GET",
      `/shout-plus/auto-approve-settings/by-business/${business_account_id}`,
      "application/json"
    )
  }
}
